<template>
  <div class="security-page bg-[#083A36]">
    <van-nav-bar :title="t('security.title')" :border="false" class="custom-nav-bar">
      <template #left>
        <Button type="back" @click="onClickLeft" />
      </template>
    </van-nav-bar>
    <div class="security-content">
      <div class="security-card">
        <div class="security-item">
          <img :src="getAssetsFile('home/account@2x.png')" alt="" class="w-[14px] h-[14px]"
            style="object-fit: contain;">
          <span class="security-label">{{ t('security.account') }}</span>
          <span class="security-value">{{ userStore.userInfo.nickname || 0 }}</span>
        </div>
        <div class="security-item">
          <img :src="getAssetsFile('home/phone@2x.png')" alt="" class="w-[14px] h-[15px]" style="object-fit: contain;">
          <span class="security-label">{{ t('security.phone') }}</span>
          <span class="security-value">{{ userStore.userInfo.phone || 0 }}</span>
        </div>
        <div class="security-item" @click="handleEmailClick">
          <img :src="getAssetsFile('home/email@2x.png')" alt="" class="w-[14px] h-[14px]" style="object-fit: contain;">
          <span class="security-label">{{ t('security.email') }}</span>
          <span class="security-unbind">{{ userStore.userInfo.email ? userStore.userInfo.email : t('security.unbind')
          }}</span>
          <img v-if="!userStore.userInfo.email" :src="getAssetsFile('home/arrow_left@2x.png')" alt=""
            class="w-[7px] h-[11px]">
        </div>
      </div>
      <div class="security-card">
        <div class="security-item" @click="goToPassword()">
          <img :src="getAssetsFile('home/password@2x.png')" alt="" class="w-[14px] h-[14px]"
            style="object-fit: contain;">
          <span class="security-label">{{ t('security.loginPassword') }}</span>
          <span class="security-status">{{ t('security.alreadySet') }}</span>
          <img :src="getAssetsFile('home/arrow_left@2x.png')" alt="" class="w-[7px] h-[11px]">
        </div>
        <div class="security-item" @click="goToWithdrawPassword()">
          <img :src="getAssetsFile('home/assetsPassword@2x.png')" alt="" class="w-[14px] h-[14px]"
            style="object-fit: contain;">
          <span class="security-label">{{ t('security.withdrawPassword') }}</span>
          <span class="security-status">{{ hasWithdrawPassword ? t('security.alreadySet') : t('security.unbind')
          }}</span>
          <img v-if="!hasWithdrawPassword" :src="getAssetsFile('home/arrow_left@2x.png')" alt=""
            class="w-[7px] h-[11px]">
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { Button } from "@/components/Button"
import router from '@/router'
import { useI18n } from 'vue-i18n'
import { onMounted, ref } from 'vue'
import { getAssetsFile } from '@/utils/pub-use'
import * as GameApi from "@/api/game"

const { t } = useI18n()
import { useUserStore, useAppStore, useUIStore, useMessageStore } from '@/stores/index'
const userStore = useUserStore()

// 检查是否已设置提现密码
const hasWithdrawPassword = ref(false)

// 获取用户信息，检查是否已设置提现密码
const checkWithdrawPassword = async () => {
  try {
    // 使用 store 的 info 方法，这样会自动更新用户信息
    await userStore.info()

    // 然后检查提现密码状态
    hasWithdrawPassword.value = !!userStore.userInfo.withdrawPassword
  } catch (error) {
    console.error('获取用户信息失败:', error)
  }
}

// 页面挂载时检查提现密码状态
onMounted(() => {
  checkWithdrawPassword()
})

// 无需 JS 逻辑
const onClickLeft = () => {
  router.replace('/person')
}
// 点击email，跳转到密码验证页面，验证成功后跳转到email页面
const goemail = () => {
  router.push('/security/parssord?redirect=email')
}

// 点击密码，跳转到密码验证页面，验证成功后跳转到重置密码页面
const goToPassword = () => {
  router.push('/security/parssord?redirect=resetPassword')
}

// 点击提现密码，根据状态决定跳转
const goToWithdrawPassword = () => {
  if (!hasWithdrawPassword.value) {
    // 如果没有设置提现密码，跳转到设置页面
    router.push('/security/parssord?redirect=senha&fromPage=security')
  }
  // 如果已经设置了，不执行任何操作（不可点击）
}

// 处理邮箱点击事件
const handleEmailClick = () => {
  if (!userStore.userInfo.email) {
    goemail()
  }
  // 如果已有邮箱，不执行任何操作
}
</script>

<style lang="scss" scoped>
.custom-nav-bar {
  height: 56px;
  box-shadow: 0px 2px 3px 0px rgba(0, 0, 0, 0.3), 0px -2px 22px 0px rgba(53, 189, 128, 0.61);

  &>* {
    height: 100%;
  }
}

.security-page {
  min-height: 100vh;
  // background: #004D37;
}

.security-navbar {
  height: 47px;
  background: #1f6749;
  display: flex;
  align-items: center;
  color: #fff;
  font-size: 22px;
  font-weight: bold;
  position: relative;
  padding: 0 0 0 8px;
}

.back-arrow {
  font-size: 22px;
  margin-right: 10px;
  cursor: pointer;
  width: 32px;
  display: inline-block;
}

.security-title {
  flex: 1;
  text-align: center;
  margin-right: 32px;
  /* 保证标题居中 */
}

.security-content {
  padding: 10px 8px 0 8px;
}

.security-card {
  background: #00554A;
  border-radius: 8px;
  margin-bottom: 11px;
  padding: 0 8px;
}

.security-item {
  display: flex;
  align-items: center;
  height: 48px;
  border-bottom: 1px solid #009F76;
  color: #fff;
  font-size: 11px;
  position: relative;
  padding: 0 15px;
}

.security-item:last-child {
  border-bottom: none;
}

.icon {
  font-size: 20px;
  margin-right: 10px;
  color: #40b665;
  width: 24px;
  text-align: center;
}

.security-label {
  flex: 1;
  margin-left: 15px;
}

.security-value {
  color: #4DB388;
  font-size: 12px;
}

.security-unbind {
  color: #4DB388;
  font-size: 12px;
  cursor: pointer;
}

.security-status {
  color: #4DB388;
  font-size: 12px;
  margin-right: 4px;
}

.arrow {
  color: #b6e2c7;
  font-size: 18px;
  margin-left: 4px;
}

.security-item.disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.security-item.disabled .security-unbind {
  cursor: not-allowed;
}
</style>
<route lang="json5">
    {
      name: 'security',
      path: '/security',
      meta: {
        title: 'Security',
        i18n: 'menus.security'
      },
    }
  </route>
